import React, { Component } from 'react';
import '../styles/loadingboxes.css';

export default class LoadingBoxes extends Component{
  render () {
      return (
          <div className="box">
            <div className="cube"></div>
            <div className="cube"></div>
            <div className="cube"></div>
            <div className="cube"></div>
          </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/loadingBoxes.js